import { render, staticRenderFns } from "./TheConnectWalletButton.vue?vue&type=template&id=54533adf"
import script from "./TheConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./TheConnectWalletButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports